module.exports = __webpack_public_path__ + "static/img/GettyImages-585142146.5938a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GettyImages-585142146.jpg
// module id = Ssst
// module chunks = 0